/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { type TopNavLink } from '../types'
import { marketingApex } from '@/lib/host'

/**
 * Default top navigation links
 *
 * In practice, navigation links are dynamically fetched from backend.
 * Priority: Backend dynamic links > Provided navLinks > defaultTopNavLinks
 *
 * These mirror the noya marketing homepage design (Model Square / API Docs /
 * Pricing / Contact). Backend-configured links always take precedence; these
 * are the fallback shown when no backend links exist, so the public header is
 * never empty. Titles are i18n source strings resolved via t() at render time.
 */
export const defaultTopNavLinks: TopNavLink[] = [
  { title: 'Model Square', href: '/models' },
  // API documentation lives on an external site — open in a new tab with an
  // external-link indicator (handled by the public header's `external` branch).
  // Deployments without a live docs site render the entry greyed-out
  // (pointer-events-none) until it's built.
  {
    title: 'API Docs',
    href: `https://docs.${marketingApex()}`,
    external: true,
    ...(!['omniapi.co', 'aiproxys.net', '4allapi.com'].includes(marketingApex())
      ? { disabled: true }
      : {}),
  },
  { title: 'Pricing', href: '/pricing' },
  { title: 'Contact', href: '/about' },
]
